import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Zap, Globe } from 'lucide-react';
import { Logo } from '../common/Logo';

export const Footer: React.FC = () => {
  return (
    <footer className="border-t border-gray-200 bg-white text-gray-600">
      <div className="container mx-auto max-w-7xl px-4 py-14 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="space-y-3.5 md:col-span-1">
            <Logo size="md" showTagline={true} />
            <p className="text-sm text-gray-600 leading-relaxed pt-1">
              Enterprise-grade cloud collaboration with communication, tasks, knowledge & AI.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-sm mb-4 text-[#111A4A] uppercase tracking-wider">Product</h4>
            <ul className="space-y-2.5 text-sm text-gray-600">
              <li><Link to="/features" className="hover:text-[#6046FF] transition">Features</Link></li>
              <li><Link to="/pricing" className="hover:text-[#6046FF] transition">Pricing</Link></li>
              <li><Link to="/download" className="hover:text-[#6046FF] transition">Download Apps</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-sm mb-4 text-[#111A4A] uppercase tracking-wider">Platform</h4>
            <ul className="space-y-2.5 text-sm text-gray-600">
              <li><span className="flex items-center gap-2"><Zap className="h-4 w-4 text-[#6046FF]" /> Real-time Sync</span></li>
              <li><span className="flex items-center gap-2"><Shield className="h-4 w-4 text-[#f7a400]" /> Analytics & Insights</span></li>
              <li><span className="flex items-center gap-2"><Globe className="h-4 w-4 text-[#6046FF]" /> Cross-Platform Sync</span></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-sm mb-4 text-[#111A4A] uppercase tracking-wider">Security</h4>
            <ul className="space-y-2.5 text-sm text-gray-600">
              <li>Built on security, reliable, faster</li>
              <li>Trusted for enterprise-grade security.</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-gray-100 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-gray-500">
          <p>© {new Date().getFullYear()} Sahaj Connect by Hutech Solutions. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-[#6046FF] transition">Privacy Policy</a>
            <a href="#" className="hover:text-[#6046FF] transition">Terms of Service</a>
            <a href="#" className="hover:text-[#6046FF] transition">Security Overview</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
